import axios from "axios";
import store from '@/store/index.js';
import router from '../router';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

instance.interceptors.request.use(
  (config) => {
    config.headers["nrs-platform"] = "web";

    const storeId = store.getters['store/getStoreId'];
    if (storeId) {
      config.headers["nrs-store-id"] = storeId;
    }

    const session = sessionStorage.getItem("bnJzLXNlc3Npb24=");
    if (session) {
      config.headers["nrs-session"] = session;
    }
    return config;
  },
  (error) => {
    console.log("request error...", JSON.stringify(error));
    return Promise.reject(error.message);
  },
);

instance.interceptors.response.use(
  (response) => {
    if (response.data?.res?.msg === 'No permissions') {
      if (response.config.url === '/123/users/logout') {
        const homePath = router.resolve({ name: 'home' }).href;

        if (router.currentRoute.path !== '/') {
          return (window.location.href = homePath);
        } else {
          return window.location.reload();
        }
      }

      store.commit('error/SHOW_ERROR', 'Your Session Expired. Please sign in', {
        root: true,
      });
      return store.dispatch('auth/logout', null, { root: true });
    }
    const session = response.data["nrs-session"];
    session && sessionStorage.setItem("bnJzLXNlc3Npb24=", session);
    const authenticatedUser = response.data["real_user"] === true;
    authenticatedUser && sessionStorage.setItem("cmVhbF91c2Vy", "dHJ1ZQ==");
    return response;
  },
  (error) => {
    console.log("response error...", JSON.stringify(error));
    if (!error.response) {
      // error.response is undefined for Network Error
      return Promise.reject(error.message);
    } else {
      if (error.response.status) {
        switch (error.response.status) {
          case 405:
            return Promise.reject(error.message);
          case 420:
            console.log("420", error.response);
            return Promise.reject(error.response.data.info.error);
        }
      }
    }
  },
);

export default instance;
